import { defineMessages } from 'react-intl'

const scope = `procurify.spending-cards.presenter.PhysicalCardPinPresenter`

export default defineMessages({
  showPinButtonText: {
    id: `${scope}.showPinButtonText`,
    defaultMessage: 'Show PIN',
  },
  fetchingPinErrorToast: {
    id: `${scope}.fetchingPinErrorToast`,
    defaultMessage: 'Error fetching card PIN',
  },
  cardAriaLabel: {
    id: `${scope}.cardAriaLabel`,
    defaultMessage: 'Spending card {cardNumber}',
  },
  visaLogoAltText: {
    id: `${scope}.visaLogoAltText`,
    defaultMessage: 'Visa logo',
  },
  availableBalanceLabel: {
    id: `${scope}.availableBalanceLabel`,
    defaultMessage: 'Available balance',
  },
})
